import { useEffect } from "react";
import axiosInstance from "./AxiosInstance";
import { useNavigate } from "react-router";

const AxiosInterceptor = ({ children }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const responseInterceptor = (response) => {
      return response;
    };

    const errorInterceptor = (error) => {
      if (error.response && error.response.status === 401) {
        navigate("/login");
      }
      return Promise.reject(error);
    };

    const interceptor = axiosInstance.interceptors.response.use(
      responseInterceptor,
      errorInterceptor
    );

    return () => axiosInstance.interceptors.response.eject(interceptor);
  }, [navigate]);

  return children;
};

export default AxiosInterceptor;
